import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import { CardWithDataRenderer } from '../CardWithData/loader';
import { CardWithURLRenderer } from '../CardWithUrl/loader';
import { isCardWithData } from '../../utils';
import { context } from '../../utils/analytics';
import { injectIntl, IntlProvider } from 'react-intl-next';
var PlainCard = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PlainCard, _React$PureComponent);
  var _super = _createSuper(PlainCard);
  function PlainCard() {
    _classCallCheck(this, PlainCard);
    return _super.apply(this, arguments);
  }
  _createClass(PlainCard, [{
    key: "render",
    value: function render() {
      var content = isCardWithData(this.props) ? /*#__PURE__*/React.createElement(CardWithDataRenderer, this.props) : /*#__PURE__*/React.createElement(CardWithURLRenderer, this.props);
      return this.props.intl ? content : /*#__PURE__*/React.createElement(IntlProvider, {
        locale: "en"
      }, content);
    }
  }]);
  return PlainCard;
}(React.PureComponent);
export var Card = withAnalyticsContext(context)(withAnalyticsEvents()(injectIntl(PlainCard, {
  enforceContext: false
})));